import { forwardRef } from "react"

const styles = {
  wrap: {
    width: "800px",
    margin: "0 auto",
    background: "#ffffff",
    color: "#111827",
    borderRadius: "12px",
    border: "1px solid #e5e7eb",
    overflow: "hidden",
  },
  header: {
    background: "#ff6a00",
    color: "#fff",
    padding: "20px 28px",
    textAlign: "center",
  },
  subHeader: {
    padding: "8px 28px",
    borderBottom: "1px solid #f1f5f9",
    background: "#fff",
    fontWeight: 600,
    letterSpacing: "1px",
    color: "#ef4444",
    textAlign: "center",
  },
  body: { padding: "24px 28px" },
  row: { display: "flex", gap: "16px", marginBottom: "12px" },
  label: { width: "220px", fontWeight: 600, color: "#374151" },
  value: { flex: 1, color: "#111827" },
  footer: {
    padding: "16px 28px",
    background: "#fff",
    color: "#6b7280",
    borderTop: "1px solid #f1f5f9",
    textAlign: "center",
  },
}

export const StudentFeeReceipt = forwardRef(function StudentFeeReceipt(
  { student = {}, fee = {}, institute = {} },
  ref,
) {
  const instituteName = institute.name || student.department_name || "Institute Name"
  const instituteCode = institute.code || student.department_code || "Institute Code"
  // Prefer explicit institute/department address, then student's department_address, then fallback to district/state
  const instituteAddress =
    institute.address ||
    student.department_address ||
    (student.department && (student.department.address || student.department.department_address)) ||
    [student.district, student.state].filter(Boolean).join(", ") ||
    "Institute address"

  const receiptNo = fee?.fee_id || fee?.transaction_id || "NA"
  const paymentDate = fee?.payment_date ? new Date(fee.payment_date) : new Date()
  const amount = typeof fee?.amount === "string" ? Number.parseFloat(fee.amount) : fee?.amount || 0
  const currency = "INR"
  const studentName = student?.name || "Student"
  const enrollmentNo = student?.enrollment_number || student?.student_code || student?.student_id || "—"
  const trade = student?.trade || "—"
  const paymentId = fee?.razorpay_payment_id || fee?.transaction_id || "—"

  return (
    <div ref={ref} style={styles.wrap}>
      <header style={styles.header}>
        <h2 style={{ fontSize: 28, fontWeight: 800, margin: 0 }}>{instituteName}</h2>
        <div style={{ opacity: 0.9, marginTop: 4, fontWeight: 600 }}>{instituteCode}</div>
      </header>

      <div style={styles.subHeader}>FEE PAYMENT RECEIPT</div>

      <section style={styles.body}>
        <div style={styles.row}>
          <div style={styles.label}>Receipt No.</div>
          <div style={styles.value}>{receiptNo}</div>
        </div>
        <div style={styles.row}>
          <div style={styles.label}>Payment Date</div>
          <div style={styles.value}>{paymentDate.toLocaleString()}</div>
        </div>
        <div style={styles.row}>
          <div style={styles.label}>Student Name</div>
          <div style={styles.value}>{studentName}</div>
        </div>
        <div style={styles.row}>
          <div style={styles.label}>Enrollment No.</div>
          <div style={styles.value}>{enrollmentNo}</div>
        </div>
        <div style={styles.row}>
          <div style={styles.label}>Trade</div>
          <div style={styles.value}>{trade}</div>
        </div>
        <div style={{ ...styles.row, marginTop: 24 }}>
          <div style={styles.label}>Amount</div>
          <div style={{ ...styles.value, fontWeight: 700 }}>
            {new Intl.NumberFormat("en-IN", { style: "currency", currency }).format(amount || 0)}
          </div>
        </div>
        <div style={styles.row}>
          <div style={styles.label}>Payment ID</div>
          <div style={styles.value}>{paymentId}</div>
        </div>
      </section>

      <footer style={styles.footer}>{instituteAddress}</footer>
    </div>
  )
})

export default StudentFeeReceipt
